module.exports = __webpack_public_path__ + "img/nodeType5.747a3b0f.svg";